import { InternalPlanPurchaseFormContext } from './InternalPlanPurchaseFormContext'
import { InternalPlanPurchaseFormContextProps } from './InternalPlanPurchaseFormContextProps'
import { useContext } from 'react'

/**
 * INTERNAL USE ONLY
 *
 * Provides an internal context for the data and functionality that the
 * PlanPurchaseForm needs to pass around.
 *
 * A subset of these properties are available publicly via the
 * `usePlanPurchaseFormContext` hook.
 */
export function useInternalPlanPurchaseFormContext(): InternalPlanPurchaseFormContextProps {
  const context = useContext(InternalPlanPurchaseFormContext)
  if (!context) {
    throw new Error('useInternalPlanPurchaseFormContext must be used within a PlanPurchaseForm')
  }
  return context
}
